import { fakeArticle } from "../utils/constants";
import { BASE_URL } from "@/network/v2";
const cheerio = require("cheerio");

export default {
  setActiveArticle(state, value) {
    try {
      const $ = cheerio.load(value.description);
      changeImgSrc($, value.title);
      changeIFrameAspect($);
      value.description = $("body").html();
    } catch {
      console.log("undef");
    }
    state.activeArticle = value;
  },

  removeActiveArtivle(state) {
    state.activeArticle = fakeArticle;
  },

  setWeatherCurrency(state, value) {
    state.weather = value.weather;
    state.currency = value.currency;
  },

  setFootball(state, value) {
    state.football = value;
  },

  setPopulation(state, value) {
    state.population = value;
  },

  setMovies(state, value) {
    state.movies = value;
  },

  // Registration
  updateUserModel(state, value) {
    state.userModel = {
      ...state.userModel,
      ...value
    }
  },

  // Main
  setAllnews(state, list) {
    state.latestNews.push(list);
  },

  setNewsCount(state, value) {
    state.newsCount = value;
  },

  incrementCurrentPage(state) {
    state.currentPage++;
  },

  flushArticleState(state) {
    state.latestNews = [];
    state.newsCount = null;
    state.currentPage = 0;
  },

  setUzbekistanNews(state, value) {
    state.uzbekistanNews = value
  },

  flushUzbekistanNews(state) {
    state.uzbekistanNews = []
  },

  // Search
  setSearchNews(state, list) {
    Array.prototype.push.apply(state.searchNews, list);
  },

  setSearchCount(state, value) {
    state.searchCount = value;
  },

  incrementSearchPage(state) {
    state.searchPage++;
  },

  flushSearchState(state) {
    state.searchNews = [];
    state.searchCount = null;
    state.searchPage = 0;
  },


  setSearchReccomend(state, list) {
    Array.prototype.push.apply(state.searchReccomend, list);
  },

  setSearchReccomendCount(state, value) {
    state.searchReccomendCount = value;
  },

  incrementSearchReccomendPage(state) {
    state.searchReccomendPage++;
  },

  flushSearchRecommendState(state) {
    state.searchReccomend = [];
    state.searchReccomendCount = null;
    state.searchReccomendPage = 0;
  },

  handleTheme(state, value) {
    if (!value) {
      if (state.theme === "dark") {
        state.theme = "light";
      } else {
        state.theme = "dark";
      }
    } else {
      state.theme = value;
    }
    typeof localStorage !== "undefined" &&
      localStorage.setItem("theme", state.theme);
  },

  // Auth
  setTokens(state, { access, refresh }) {
    setAccessToken(state, access);
    setRefreshToken(state, refresh);
  },

  setAccessToken(state, value) {
    setAccessToken(state, value);
  },

  setRefreshToken(state, value) {
    setRefreshToken(state, value);
  },

  flushTokens(state) {
    removeRefreshToken(state);
    removeAccessToken(state);
  },

  // Staff
  setUser(state, value) {
    state.user = value;
  },

  updateNewArticle(state, value) {
    state.newArticle = {
      ...state.newArticle,
      ...value
    };
  },
  flushNewArticle(state) {
    state.newArticle = {};
  },

  setCountries(state, value) {
    state.countries = value
  },


  setSubCategories(state, value) {
    state.subCategories = value;
  },

  setTags(state, value) {
    state.tags = value;
  },

  // Staff News
  setStaffNews(state, list) {
    Array.prototype.push.apply(state.staffNews, list);
  },

  setStaffCount(state, value) {
    state.staffCount = value;
  },

  incrementStaffPage(state) {
    state.staffPage++;
  },

  flushStaffState(state) {
    state.staffNews = [];
    state.staffCount = null;
    state.staffPage = 0;
  },

  // admin News
  setAdminNews(state, value) {
    state.adminNews = value
  },

  setAdminCount(state, value) {
    state.adminCount = value;
  },

  setAdminPage(state, value) {
    state.adminPage = value;
  },

  setAuthorsList(state, value) {
    state.authorsList = value
  },

  flushAdminNews(state) {
    state.adminNews = [];
    state.adminCount = null;
    state.adminPage = 0;
  },

  // Staff Team
  setEmployees(state, list) {
    Array.prototype.push.apply(state.employees, list);
  },

  setEmployeesCount(state, value) {
    state.employeesCount = value;
  },

  incrementEmployeesPage(state) {
    state.employeesPage++;
  },

  flushEmployeesState(state) {
    state.employees = [];
    state.employeesCount = null;
    state.employeesPage = 0;
  },

  setJournalists(state, list) {
    Array.prototype.push.apply(state.journalists, list);
  },

  setJournalistsCount(state, value) {
    state.journalistsCount = value;
  },

  incrementJournalistsPage(state) {
    state.journalistsPage++;
  },

  flushJournalistsState(state) {
    state.journalists = [];
    state.journalistsCount = null;
    state.journalistsPage = 0;
  },
};

function setAccessToken(state, value) {
  state.access = value;
  if (typeof localStorage !== "undefined") localStorage.setItem('access', value);
}

function setRefreshToken(state, value) {
  state.refresh = value;
  if (typeof localStorage !== "undefined") localStorage.setItem('refresh', value);
}

function removeRefreshToken(state) {
  state.refresh = null;
  if (typeof localStorage !== "undefined") localStorage.removeItem('refresh');
}

function removeAccessToken(state) {
  state.access = null;
  if (typeof localStorage !== "undefined") localStorage.removeItem('access');
}

function changeImgSrc($, alt) {
  for (const element of $("img")) {
    if (element.attribs.src.charAt(0) === "/") {
      element.attribs.src = BASE_URL + element.attribs.src;
      if (!element.attribs.alt || element.attribs.alt.length === 0) {
        element.attribs.alt = alt;
      }
    }
  }
}

function changeIFrameAspect($) {
  for (const element of $("iframe")) {
    element.parent.attribs.style = "position: relative; padding-top: 56.25%;";
  }
}

// function changeImgSrc(doc) {
//   doc.getElementsByTagName("img").forEach((element) => {
//     if (typeof window !== "undefined") {
//       if (new URL(element.src).hostname === window.location.hostname)
//         element.src = new URL(new URL(element.src).pathname, BASE_URL);
//     } else {
//       if (new URL(element.src).hostname === "zamon.uz")
//         element.src = new URL(new URL(element.src).pathname, BASE_URL);
//     }
//   });
//   return doc
// }

// function changeIFrameAspect(doc) {
//   doc.getElementsByTagName("iframe").forEach((element) => {
//     element.parentNode.style.position = "relative";
//     element.parentNode.style.paddingTop = "56.25%"; // 16:9 Aspect Ratio
//   });
//   return doc
// }

// function createThread (state, id) {
//   state.threads = {
//     ...state.threads,
//     [id]: {
//       id,
//       messages: [],
//       lastMessage: null
//     }
//   }
// }
